<div class="top-up">
  <p class="top-up__balance" i18n="@@topUp.balance">Refund return balance: {{topUp}}</p>
  <p class="top-up__subtitle" i18n="@@topUp.subtitle">Your available balance for handling refunds.</p>
</div>